export const passwordPattern = (): RegExp => /\S{7,}/gi;

export const containingSpacesPattern = (): RegExp => /\s/gi;

export const userNamePattern = (): RegExp => /(([a-zA-Z]|[\xC0-\uFFFF]|\d|-)+\s?)+/g;

export type OnValidatedCallback = (validationResult: Promise<boolean>) => Promise<void>;

export const LANG = {
  EN: 'en',
  NL: 'nl',
  DE: 'de',
  UK: 'uk',
  FR: 'fr',
  ES: 'es',
  IT: 'it',
  RU: 'ru',
  CA: 'ca',
  PL: 'pl'
};

export const MAX_LENGTH = {
  NAME: 256,
  EMAIL: 100,
  PASSWORD: 100
};

export function getTooltipDefaultOptions() {
  return {
    defaultOffset: 5,
    defaultTemplate:
    // eslint-disable-next-line max-len
      '<div class="eg-tooltip dashboard-tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-contents"></div></div>',
    defaultInnerSelector: '.tooltip-contents',
    defaultHandleResize: true,
    defaultPopperOptions: {
      modifiers: {
        computeStyle: {
          gpuAcceleration: false
        },
        preventOverflow: {
          boundariesElement: 'viewport'
        }
      }
    },
    popover: {
      defaultOffset: 5,
      defaultInnerClass: 'popover-contents',
      defaultHandleResize: true,
      defaultPopperOptions: {
        modifiers: {
          computeStyle: {
            gpuAcceleration: false
          },
          preventOverflow: {
            boundariesElement: 'viewport'
          }
        }
      }
    }
  };
}

export const ELLIPSIS_PLACEHOLDER = '...';

export const UPDATED_DESC = 'updatedAt=desc';

export function getSortOptions(localize: (arg: string) => string) {
  return [
    {
      key: UPDATED_DESC,
      text: localize('recentlyOpened')
    },
    {
      key: 'createdAt=desc',
      text: localize('recentlyAdded')
    },
    {
      key: 'score=asc',
      text: localize('progressLowHigh')
    },
    {
      key: 'score=desc',
      text: localize('progressHighLow')
    },
    {
      key: 'title=asc',
      text: localize('nameAZ')
    },
    {
      key: 'title=desc',
      text: localize('nameZA')
    }
  ];
}
